export default __webpack_public_path__ + "static/media/proof1.c1aecb23.jpg";